export const FEATURE_FLAG = {
  BILLING_ENGINE_MVP: "billing-engine-mvp",
  MULTI_ORG: "multi-org",
  USAGE_REPORTING: "usage-reporting"
};
